import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './FAQSection.css';

const faqs = [
  {
    question: 'What services does Virves Software Solutions offer?',
    answer: 'We offer custom software development, web development, mobile app development, cloud solutions, UI/UX design, and AI & automation services for startups and enterprises.'
  },
  {
    question: 'How do I get started with a project?',
    answer: 'Simply contact us through our website or email. We will schedule a discovery call to understand your needs and propose a tailored solution.'
  },
  {
    question: 'What is your development process?',
    answer: 'Our process includes requirements gathering, planning, design, development, testing, deployment, and ongoing support. We use agile methodologies for flexibility and transparency.'
  },
  {
    question: 'Do you work with startups as well as enterprises?',
    answer: 'Yes! We work with clients of all sizes, from early-stage startups to established enterprises, adapting our approach to fit your needs and budget.'
  },
  {
    question: 'How much does a typical project cost?',
    answer: 'Project costs vary based on scope, complexity, and timeline. After an initial consultation, we provide a detailed proposal and transparent pricing.'
  },
  {
    question: 'Can you help with ongoing maintenance and support?',
    answer: 'Absolutely. We offer ongoing maintenance, support, and feature enhancements to ensure your product remains up-to-date and effective.'
  },
  {
    question: 'What technologies do you specialize in?',
    answer: 'We specialize in modern web frameworks (React, Angular, Vue), mobile (iOS, Android, Flutter), backend (Node.js, Python), cloud (AWS, GCP, Azure), and more.'
  },
  {
    question: 'How do you ensure the quality of your deliverables?',
    answer: 'We follow best practices in code quality, automated testing, code reviews, and continuous integration to ensure robust, reliable solutions.'
  },
  {
    question: 'Can you work with my existing team or project?',
    answer: 'Yes, we can collaborate with your in-house team or take over ongoing projects, providing expertise and additional resources as needed.'
  },
  {
    question: 'How do you communicate during a project?',
    answer: 'We use regular meetings, email, and project management tools to keep you updated and involved throughout the project lifecycle.'
  }
];

const FAQSection = () => (
  <Box className="faq-section-bg">
    <Container maxWidth="md">
      <Typography variant="h2" className="faq-section-title" gutterBottom>
        Frequently Asked Questions
      </Typography>
      {faqs.map((faq, idx) => (
        <Accordion key={idx} className="faq-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="faq-accordion-summary">
            <Typography className='faq-question'>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails className="faq-accordion-details">
            <Typography>{faq.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  </Box>
);

export default FAQSection; 